const stadtnah = [
    'Jordanshöhe',
    'Mariechenweg',
    'Engelsburger',
    'Panorama-Sperrental',
    'Sperrental-Kuppe'
];

function addRouteLink(routeName) {
    if (routeName.indexOf('-nobar') > 0) {
        routeName = routeName.substring(0, routeName.indexOf('-nobar'));
    } else if (RouteHelper.stadtnah.indexOf(routeName) > -1) {
        return 0;
    }
    const routeInfo = document.getElementById('routeInfo');
    const nameElement = document.createElement('span');
    nameElement.textContent = 'Zurück zur ';
    routeInfo.appendChild(nameElement);

    const a = document.createElement('a');
    a.setAttribute('href', 'https://www.wandern-andreasberge.de/wandern/' + routeName + '.html');
    a.appendChild(
        document.createTextNode('Routenbeschreibung ' + routeName)
    );
    routeInfo.appendChild(a);
}

function addWanderIndexLink(pageSection) {
    const routeInfo = document.getElementById('routeInfo');
    const nameElement = document.createElement('span');
    nameElement.textContent = 'Zurück zur ';
    routeInfo.appendChild(nameElement);

    const a = document.createElement('a');
    let url = 'https://www.wandern-andreasberge.de/wandern/index.html';
    if (typeof pageSection === 'string') {
        url += '#' + pageSection;
    }
        
    a.setAttribute('href', url);
    a.appendChild(
        document.createTextNode('Wanderseite')
    );
    routeInfo.appendChild(a);
}


function removeRouteInfo() {
    const routeInfo = document.getElementById('routeInfo');
    routeInfo.innerHTML = '';
}

const RouteHelper = {};
RouteHelper.stadtnah = stadtnah;
RouteHelper.addWanderIndexLink = addWanderIndexLink;
RouteHelper.addRouteLink = addRouteLink;
RouteHelper.removeRouteInfo = removeRouteInfo;
export default RouteHelper;
